import { render, staticRenderFns } from "./EditIns.vue?vue&type=template&id=72f12abc&scoped=true&"
import script from "./EditIns.vue?vue&type=script&lang=js&"
export * from "./EditIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f12abc",
  null
  
)

export default component.exports